export default "__VITE_ASSET__BPpHRfu6__"